<template>
  <b-container class="mw-100 mt-3">
    <b-card class="mt-4 mb-4">
      <standard-table ref="vehicleTable"
                      :items="insuranceItems"
                      :fields="insuranceFields"
                      :search-place-holder="`${$tc('message.example', 1)}: AA999ZZ`"

                      :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                      :row-after-search="{cols: 12, sm: 12, md: 12, lg: 8, xl: 8, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"

                      :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                      :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 4}"
                      :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 2}"
                      :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 3, xl: 1}"

                      :search-label-horizontal="false"
                      fullWidth="true"
                      noContainerPadding="true"

                      @rowEdit="pushToEdit($event.item)">

        <b-container slot="row-after-search" class="mw-100 p-0 ">
          <b-row>
            <b-col cols="auto">
              <b-button v-on:click="resetFilters()" class="b-c-green" id="reset-filters">
                {{$t('message.resetFilters')}}
              </b-button>
            </b-col>

            <b-col cols="auto" class="mb-3">
              <b-button @click="showCollapse = !showCollapse" :class="showCollapse ? 'b-c-red' : 'b-c-green'">
                <span v-show="!showCollapse" class="when-opened">{{$t('message.show')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
                <span v-show="showCollapse" class="when-closed">{{$t('message.hide')}} {{$tc('message.filter', 2).toLowerCase()}}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-container>

        <b-container slot="after-search" class="mw-100 p-0">
          <b-collapse id="my-collapse" v-model="showCollapse">
            <b-container class="mw-100 m-0 p-0">
              <b-row>
                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="$t('message.insuranceCompany')"
                                label-for="input-company">
                    <model-list-select id="input-company"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="insuranceCompanyOptions && insuranceCompanyOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="insuranceCompanyFilter"
                                       :list="insuranceCompanyOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="6" lg="4" xl="4">
                  <b-form-group :label="`${$t('message.inOperation')}`"
                                label-for="input-removed">
                    <model-list-select id="input-removed"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="removedOptions && removedOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="removedFilter"
                                       :list="removedOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
          </b-collapse>
        </b-container>

        <b-container slot="row-after-per-page" class="mw-100 p-0">
          <b-row>
            <b-col>
              <b-button class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0" id="excel-button" @click="$refs.vehicleTable.excel($tc('message.insurance', 2))">Excel</b-button>
            </b-col>
          </b-row>
        </b-container>
      </standard-table>
    </b-card>
  </b-container>
</template>

<script>
import Vue from 'vue'
import { DateTime } from 'luxon'
import { find, orderBy, cloneDeep, filter } from 'lodash'

export default {
  name: 'Insurance',
  created () {
    this.fetchData()
  },
  mounted () {
    this.$root.$on('change-lang', () => {
      if (this.$el.isConnected) {
        this.getStaticOptions()
        this.updateLinks()
      }
    })
  },
  data () {
    const config = this.$route.meta.config

    return {
      config,
      DateTime,
      insuranceCompanyOptions: [],
      insuranceOriginalItems: [],
      insuranceItems: [],
      insuranceFields: [],
      removedOptions: [],
      paymentOptions: [],
      removedFilter: '',
      insuranceCompanyFilter: null,
      links: [
        '/configuration/insurance_company'
      ],
      showCollapse: false
    }
  },
  watch: {
    'insuranceCompanyFilter' (val) {
      this.insuranceItems = this.getItems(val, this.removedFilter)
    },
    removedFilter (val) {
      this.insuranceItems = this.getItems(this.insuranceCompanyFilter, val)
    }
  },
  methods: {
    clickedLink (link) {
      if (link.href) {
        this.$router.push(link.href)
      }
    },
    fetchData () {
      this.$root.$emit('activeLoader', true)
      this.getOptions().then(() => this.getInsurances())
    },
    getOptions () {
      const axiosArray = []
      this.getStaticOptions()
      axiosArray.push(this.getEnum('insurance_company', 'insuranceCompanyOptions'))
      return Vue.myAll(axiosArray).then(r => r)
    },
    getStaticOptions () {
      this.getFields()
      this.getRemovedOptions()
      this.getPaymentOptions()
    },
    getFields () {
      this.insuranceFields = [
        // config[crud], create - read - update - delete
        { key: 'edit', label: '', hideInTable: !this.config.u && !this.config.r },
        { key: 'number', label: `${this.$tc('message.number', 1)} ${this.$tc('message.insurance', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc' },
        { key: 'descr', label: this.$tc('message.insuranceCompany', 1), sortable: true, sortDirection: 'desc' },
        { key: 'parsedStartDate', label: `${this.$tc('message.date', 1)} ${this.$t('message.start').toLowerCase()}`, sortable: true, sortDirection: 'desc' },
        { key: 'parsedEndDate', label: `${this.$tc('message.date', 1)} ${this.$t('message.expiration').toLowerCase()}`, sortable: true, sortDirection: 'desc' },
        { key: 'parsedPaymentFrequency', label: `${this.$t('message.frequency')} ${this.$t('message.payment').toLowerCase()}`, sortable: true, sortDirection: 'desc' },
        { key: 'vehicle', label: this.$tc('message.vehicle', 1), sortable: true, sortDirection: 'desc' },
        { key: 'removedText', label: `${this.$t('message.inOperation')}`, sortable: true, sortDirection: 'desc' }
      ]
    },
    getRemovedOptions () {
      this.removedOptions = [
        { value: '', text: this.$t('message.all') },
        { value: false, text: this.$t('message.yes') },
        { value: true, text: this.$t('message.no') }
      ]
    },
    getPaymentOptions () {
      this.paymentOptions = [
        { value: 1, text: this.$t('message.monthly') },
        { value: 3, text: this.$t('message.quarterly') },
        { value: 6, text: this.$t('message.semiannual') },
        { value: 12, text: this.$t('message.yearly') }
      ]
    },
    getEnum (path, obj) {
      const options = []
      return Vue.myGet(this, `/enums/${path}`, 'data').then((items) => {
        options.push({ value: '', text: items.length !== 0 ? this.$t('message.selectOption') : this.$t('message.noOption') })
        items.forEach((item) => {
          options.push({ value: item.id, text: item.descr })
        })
        if (obj) {
          this[obj] = options
        }
        return options
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    getInsurances () {
      Vue.myGet(this, '/vehicles?all=true', 'vehicles').then((vehicles) => {
        const insurances = []
        vehicles.forEach((vehicle) => {
          if (vehicle && vehicle.insurances && vehicle.insurances.length !== 0) {
            vehicle.insurances.forEach((insurance) => {
              const editedInsurance = insurance
              const foundedPaymentFreq = find(this.paymentOptions, obj => parseInt(obj.value) === parseInt(editedInsurance.paymentFreq))
              const brand = vehicle.type && vehicle.type.brand ? `- ${vehicle.type.brand}` : ''
              const model = vehicle.type && vehicle.type.model ? `- ${vehicle.type.model}` : ''
              editedInsurance.descr = find(this.insuranceCompanyOptions, obj => obj.value === insurance.company).text
              editedInsurance.vehicle = `${vehicle.plateNumber} ${brand} ${model}`
              editedInsurance.vehicleId = vehicle.id
              editedInsurance.vehicleRemoved = !!vehicle.disablingDate
              editedInsurance.removedText = !vehicle.disablingDate ? this.$t('message.yes') : this.$t('message.no')
              editedInsurance.parsedPaymentFrequency = foundedPaymentFreq ? foundedPaymentFreq.text : this.$tc('message.emptyValue', 1)
              editedInsurance.parsedStartDate = DateTime.fromSQL(editedInsurance.startDate).toFormat('dd-MM-y')
              editedInsurance.parsedEndDate = DateTime.fromSQL(editedInsurance.endDate).toFormat('dd-MM-y')
              insurances.push(editedInsurance)
            })
          }
        })
        this.insuranceOriginalItems = orderBy(insurances, 'number')
        this.insuranceItems = cloneDeep(this.insuranceOriginalItems)
        this.$root.$emit('activeLoader', false)
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
      })
      this.updateLinks()
    },
    getItems (insuranceCompany, removed) {
      let originalItems = cloneDeep(this.insuranceOriginalItems)
      if (insuranceCompany && insuranceCompany !== '') {
        originalItems = filter(originalItems, obj => obj.company === insuranceCompany)
      }
      if (removed !== '') {
        originalItems = filter(originalItems, obj => obj.vehicleRemoved === removed)
      }
      return originalItems
    },
    pushToEdit (item) {
      item && item.vehicleId ? this.$router.push({
        name: 'EditVehicle', params: { id: item.vehicleId }, query: { tab: 'insurance' }
      }) : this.$router.push({
        name: 'EditVehicle', params: { id: 'new' }
      })
    },
    resetFilters () {
      this.insuranceCompanyFilter = ''
      this.removedFilter = ''
      this.$refs.vehicleTable.resetSearch()
    },
    updateLinks () {
      const links = []
      this.links.forEach(link => {
        links.push({ href: link })
      })
      this.$root.$emit('change-links', links)
    }
  }
}
</script>

<style scoped>

</style>
